"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSeriesEndDateProperty = exports.seriesEndDatePropertyDefinition = void 0;
exports.seriesEndDatePropertyDefinition = {
    view: { label: 'Series end date' },
    constraints: [],
    type: 'date',
    multiple: false,
    name: 'series-end-date',
};
const isSeriesEndDateProperty = (prop) => {
    return prop.name === exports.seriesEndDatePropertyDefinition.name;
};
exports.isSeriesEndDateProperty = isSeriesEndDateProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VyaWVzLWVuZC1kYXRlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvc2VyaWVzLWVuZC1kYXRlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsK0JBQStCLEdBQUc7SUFDN0MsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGlCQUFpQixFQUFFO0lBQ2xDLFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxpQkFBaUI7Q0FDUSxDQUFBO0FBSTFCLE1BQU0sdUJBQXVCLEdBQUcsQ0FBQyxJQUFrQixFQUFpQyxFQUFFO0lBQzNGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx1Q0FBK0IsQ0FBQyxJQUFJLENBQUE7QUFDM0QsQ0FBQyxDQUFBO0FBRlksUUFBQSx1QkFBdUIsMkJBRW5DIn0=